import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const iconMap: Record<string, string> = {
  all: 'ri-apps-line',
  action: 'ri-flashlight-line',
  comedy: 'ri-emotion-happy-line',
  romance: 'ri-heart-line',
  scifi: 'ri-rocket-line',
  horror: 'ri-ghost-line',
  drama: 'ri-slideshow-line',
  animation: 'ri-paint-brush-line',
  documentary: 'ri-camera-line',
  tv: 'ri-tv-line',
  variety: 'ri-mic-line',
  anime: 'ri-aliens-line',
};

export default function CategoryNav() {
  return (
    <section className="py-6 md:py-8">
      <div className="container-main">
        <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide flex-nowrap">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
              className="flex flex-col items-center gap-1.5 shrink-0 group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-background-200/80 group-hover:bg-primary-500/20 flex items-center justify-center transition-all duration-300">
                <i className={`${iconMap[cat.slug] || 'ri-movie-line'} text-lg md:text-xl text-foreground-400 group-hover:text-primary-400 transition-colors w-5 h-5 md:w-6 md:h-6 flex items-center justify-center`}></i>
              </div>
              <span className="text-xs text-foreground-500 group-hover:text-foreground-300 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}